import { render, staticRenderFns } from "./FilterBySeverity.vue?vue&type=template&id=57b4255f"
import script from "./FilterBySeverity.vue?vue&type=script&lang=js"
export * from "./FilterBySeverity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports